import { SVGProps, Ref, forwardRef } from 'react';

export const CompanysLifeOutlinedCircledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.667 6.158C6.167 6.158 5 7.325 5 10.825c0 3.325 1.053 4.544 4.16 4.658L12 18.992l2.842-3.51C17.947 15.37 19 14.15 19 10.826c0-3.5-1.167-4.667-4.667-4.667zm1.621 5.834c0 .047.018.112.09.189.11.117.328.23.622.23s.512-.113.622-.23c.072-.077.09-.142.09-.19h1.493c0 .479-.2.898-.494 1.212-.422.45-1.05.702-1.711.702-.66 0-1.29-.253-1.711-.702a1.77 1.77 0 0 1-.494-1.211zm2.754-3.5c-.766 0-1.021.51-1.021 1.02 0 .511.255 1.021 1.02 1.021.766 0 1.021-.51 1.021-1.02s-.255-1.021-1.02-1.021m-5.105 1.02c0-.51.256-1.02 1.021-1.02.766 0 1.021.51 1.021 1.02 0 .511-.255 1.021-1.02 1.021-.766 0-1.022-.51-1.022-1.02"
                    fill="currentColor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 1C3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11S20.25 1 12 1M4.789 5.59C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
CompanysLifeOutlinedCircledSize24Glyph.displayName = 'CompanysLifeOutlinedCircledSize24Glyph';
